import {I18n} from "@aws-amplify/core";
import {Badge} from "@mantine/core";
import {BindingDriftReport, DriftAction} from "../types.ts";
import {runNeedsAttention} from "../utils/runHealth.ts";

type RunCounts = Pick<BindingDriftReport, 'driftDetectedCount' | 'repairFailedCount' | 'repairCappedCount'>;

// Health badge for a sweep run. Green when clean; red when repairs failed or the cap
// was hit; gray when there was simply no drift to act on.
export const RunHealthBadge = ({record}: { record: RunCounts }) => {
    if (runNeedsAttention(record)) {
        const reason = (record.repairFailedCount ?? 0) > 0 ? 'Repair failed' : 'Repair capped';
        return <Badge color={'red'}>{I18n.get(reason)}</Badge>;
    }
    if ((record.driftDetectedCount ?? 0) > 0) {
        return <Badge color={'green'}>{I18n.get('Drift repaired')}</Badge>;
    }
    return <Badge color={'gray'}>{I18n.get('No drift')}</Badge>;
};

// Per-account finding action badge. The action is the sweep's own code, shown
// verbatim so it matches the logs and alarms an operator cross-references.
export const ActionBadge = ({action}: { action: DriftAction | string }) => {
    let color = 'gray';
    if (action === 'REPAIRED') {
        color = 'green';
    } else if (action === 'REPAIR_FAILED') {
        color = 'red';
    } else if (action === 'CAP_EXCEEDED') {
        color = 'orange';
    } else if (action === 'SKIPPED_TOCTOU' || action === 'SKIPPED_STATUS') {
        color = 'yellow';
    }
    return <Badge color={color}>{action}</Badge>;
};
